import UploadFile from "../../../upload-file/UploadFile";
import FileIcon from "../../../upload-file/file-icon/FileIcon";
import Styles from "../editScreenStyles.module.css";

function DocumentsEdit({ documents, handleDocuments, config, setIsVisible }) {
  const doneClicked = () => {
    setIsVisible(false);
  };

  return (
    <div>
      <div className={Styles.title}>Documents</div>
      <div className={Styles.column}>
        <div className={Styles.column}>
          <UploadFile
            getFiles={(files) => handleDocuments(files, "add")}
            size={(documents.size / config.totalFileSizeLimitDivisor).toFixed(
              2
            )}
          />

          <div className="documentContainer">
            {documents.files &&
              documents.files.map((document, index) => {
                return (
                  <FileIcon
                    key={index}
                    file={document}
                    removeFile={(file) => handleDocuments(file, "remove")}
                  />
                );
              })}
          </div>
        </div>
        <div className={Styles.buttons}>
          <button type="button" className={Styles.button} onClick={doneClicked}>
            Finished
          </button>
        </div>
      </div>
    </div>
  );
}

export default DocumentsEdit;
